// ASCII文字（半角英数字・記号）のみ許可するフィルタ（パスワード用）
const toAsciiOnly = (str) => str.replace(/[^\x20-\x7E]/g, "");

/**
 * RegiFormRow - レジ1行分のフォーム（ShopManagementForm から独立させた molecule）
 *
 * @param {object}   regi         - レジ1行分の入力state
 * @param {number}   idx          - registers配列内のインデックス（エラーキー・onChange用）
 * @param {boolean}  isEdit       - 編集モードかどうか
 * @param {boolean}  canRemove    - 「削除」リンクを表示するか（新規行かつ複数行ある場合）
 * @param {object}   errors       - バリデーションエラー { [key]: message }
 * @param {boolean}  submitting   - 送信中の非活性フラグ
 * @param {function} onChange     - (idx, field, value) => void 入力変更ハンドラ
 * @param {function} onRemove     - 「削除」リンク押下ハンドラ（新規行の一時削除）
 * @param {function} onDeactivate - 「無効化」ボタン押下ハンドラ（既存レジの無効化）
 */
function RegiFormRow({
  regi,
  idx,
  isEdit,
  canRemove,
  errors,
  submitting,
  onChange,
  onRemove,
  onDeactivate,
}) {
  const isNew = regi.regiNo === null;

  return (
    <div className="border border-gray-200 rounded p-3 mb-3 bg-gray-50">
      {/* ヘッダー行 */}
      <div className="flex justify-between items-center mb-4">
        <span className="text-base font-medium text-gray-700">
          {isNew ? "新規レジ" : `レジ No.${regi.regiNo}`}
        </span>
        <div className="flex gap-3 items-center">
          {canRemove && (
            <button
              type="button"
              onClick={onRemove}
              disabled={submitting}
              className="text-base text-gray-400 hover:text-gray-600 disabled:opacity-40"
            >
              ✕ 削除
            </button>
          )}
          {!isNew && isEdit && (
            <button
              type="button"
              onClick={onDeactivate}
              disabled={submitting}
              className="text-base border border-red-300 text-red-500 rounded px-3 py-1 hover:bg-red-50 hover:border-red-400 hover:text-red-600 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              無効化
            </button>
          )}
        </div>
      </div>

      {/* 入力フィールド */}
      {[
        { label: "レジ部門名 *", field: "regiName", type: "text" },
        { label: "担当者名", field: "userName", type: "text" },
        { label: "ログインID *", field: "userID", type: "text" },
      ].map(({ label, field, type }) => (
        <div key={field} className="flex items-start gap-3 mb-2">
          <label className="text-base text-gray-600 w-28 shrink-0 pt-1">
            {label}
          </label>
          <div className="flex-1">
            <input
              type={type}
              value={regi[field]}
              onChange={(e) => onChange(idx, field, e.target.value)}
              className="border border-gray-400 rounded px-2 py-1 text-base w-full"
              disabled={submitting}
            />
            {errors[`regi_${idx}_${field}`] && (
              <p className="text-red-600 text-base mt-1">
                {errors[`regi_${idx}_${field}`]}
              </p>
            )}
          </div>
        </div>
      ))}

      {/* パスワード欄 */}
      <div className="flex items-start gap-3 mb-2">
        <label className="text-sm text-gray-600 w-28 shrink-0 pt-1">
          パスワード{isNew ? " *" : ""}
        </label>
        <div className="flex-1">
          <input
            type="password"
            value={regi.password}
            onChange={(e) => onChange(idx, "password", toAsciiOnly(e.target.value))}
            autoComplete="new-password"
            className="border border-gray-400 rounded px-2 py-1 text-sm w-full"
            disabled={submitting}
          />
          {errors[`regi_${idx}_password`] && (
            <p className="text-red-600 text-xs mt-1">
              {errors[`regi_${idx}_password`]}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-start gap-3 mb-1">
        <label className="text-sm text-gray-600 w-28 shrink-0 pt-1">
          確認用
        </label>
        <div className="flex-1">
          <input
            type="password"
            value={regi.confirmPassword}
            onChange={(e) => onChange(idx, "confirmPassword", toAsciiOnly(e.target.value))}
            autoComplete="new-password"
            className="border border-gray-400 rounded px-2 py-1 text-sm w-full"
            disabled={submitting}
          />
          {errors[`regi_${idx}_confirmPassword`] && (
            <p className="text-red-600 text-xs mt-1">
              {errors[`regi_${idx}_confirmPassword`]}
            </p>
          )}
        </div>
      </div>

      <p className="text-sm text-gray-400 ml-[7.75rem]">
        {isNew
          ? "新規追加時は必須です"
          : "空欄の場合、現在のパスワードを維持します"}
      </p>
    </div>
  );
}

export default RegiFormRow;
